import React from 'react';
import { useResearchSSE } from './hooks/useResearchSSE';
import ResearchForm from './components/ResearchForm';
import ProgressIndicator from './components/ProgressIndicator';
import SearchPlan from './components/SearchPlan';
import SearchResults from './components/SearchResults';
import ResearchReport from './components/ResearchReport';

function App() {
  const { state, startResearch, resetResearch } = useResearchSSE();

  const handleNewResearch = () => {
    resetResearch();
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header with reset button when research is completed */}
        {(state.currentPhase === 'completed' || state.currentPhase === 'error') && (
          <div className="w-full max-w-4xl mx-auto mb-6">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-semibold text-gray-900">
                Research Results for: "{state.query}"
              </h2>
              <button
                onClick={handleNewResearch}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center space-x-2"
              >
                <span>🔄</span>
                <span>New Research</span>
              </button>
            </div>
          </div>
        )}

        {/* Research Form - only show when idle or error */}
        {(state.currentPhase === 'idle' || state.currentPhase === 'error') && (
          <ResearchForm
            onSubmit={startResearch}
            isLoading={state.isRunning}
          />
        )}

        {/* Progress Indicator */}
        <ProgressIndicator state={state} />

        {/* Search Plan */}
        <SearchPlan
          searchPlan={state.searchPlan}
          isVisible={state.searchPlan.length > 0}
        />

        {/* Search Results */}
        <SearchResults
          searchResults={state.searchResults}
          isVisible={state.currentPhase === 'searching' || state.currentPhase === 'writing' || state.currentPhase === 'completed'}
          searchesCompleted={state.searchesCompleted}
          searchesTotal={state.searchesCount}
        />

        {/* Research Report */}
        <ResearchReport
          report={state.report}
          isVisible={state.currentPhase === 'completed'}
        />

        {/* Debug Events (optional, for development) */}
        {process.env.NODE_ENV === 'development' && state.events.length > 0 && (
          <div className="w-full max-w-4xl mx-auto mt-8">
            <details className="bg-gray-100 rounded-lg p-4">
              <summary className="cursor-pointer font-medium text-gray-700">
                Debug: SSE Events ({state.events.length})
              </summary>
              <div className="mt-4 space-y-2">
                {state.events.map((event, index) => (
                  <div key={index} className="text-xs bg-white p-2 rounded border">
                    <div className="font-mono text-blue-600">{event.type}</div>
                    <div className="font-mono text-gray-500 text-xs">{event.timestamp}</div>
                    <pre className="mt-1 text-gray-700 overflow-x-auto">
                      {JSON.stringify(event.data, null, 2)}
                    </pre>
                  </div>
                ))}
              </div>
            </details>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
